import PropTypes from 'prop-types';
import FullWidthTemplate from '../components/templates/FullWidthTemplate/FullWidthTemplate';
import PageMetadata from '../components/PageMetadata/PageMetadata';
import Hero from '../components/Hero/Hero';
import Content from '../components/Content/Content';
import DestinationList from '../components/Destinations/DestinationList/DestinationList';
import ErrorPage from './500';
import { getDestinationsPage } from '../services/contentService';
import styles from '../styles/pages/destinations.module.scss';

function Destinations({ data }) {
    if (data.error) {
        return <ErrorPage />;
    }

    return (
        <FullWidthTemplate className={styles.destinations}>
            <PageMetadata
                title={data.meta.title}
                description={data.meta.description}
                relativeUrl="/destinations"
                imageUrl={data.image}
            />
            <Hero
                heading={data.heading}
                subheading={data.subheading}
                imgSrc={data.image}
            />
            <Content className={styles.content} content={data.content} />
            <DestinationList
                className={styles.destinationList}
                destinations={data.destinations}
            />
        </FullWidthTemplate>
    );
}

Destinations.propTypes = {
    data: PropTypes.shape({
        notFound: PropTypes.bool.isRequired,
        error: PropTypes.string,
        heading: PropTypes.string.isRequired,
        subheading: PropTypes.string,
        image: PropTypes.string.isRequired,
        content: PropTypes.string,
        meta: PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
        }),
        destinations: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
                imgSrc: PropTypes.string.isRequired,
                children: PropTypes.array,
            })
        ),
    }),
};

export async function getServerSideProps() {
    const data = await getDestinationsPage();
    return { props: { data }, notFound: data.notFound };
}

export default Destinations;
